var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main", "aria-label": "content" } }, [
    _c("header"),
    _vm._v(" "),
    _c("main", [
      _c("section", { staticClass: "section section--movie" }, [
        _c(
          "div",
          { staticClass: "section__inner-wrapper" },
          [
            _c(
              "div",
              { staticClass: "section__header" },
              [
                _c("breadcrumb", {
                  attrs: { steps: [["Home", "/"], ["Movies"]] }
                }),
                _vm._v(" "),
                _c("h1", { staticClass: "section__title" }, [_vm._v("Movies")])
              ],
              1
            ),
            _vm._v(" "),
            _vm.isLoading
              ? _c("div", { staticClass: "c-loading c-loading--movies" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "lds-dual-ring",
                      staticStyle: { background: "0 0" },
                      attrs: {
                        width: "100",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 100 100",
                        preserveAspectRatio: "xMidYMid"
                      }
                    },
                    [
                      _c(
                        "circle",
                        {
                          attrs: {
                            cx: "50",
                            cy: "50",
                            fill: "none",
                            "stroke-linecap": "round",
                            r: "40",
                            "stroke-width": "4",
                            stroke: "#363472",
                            "stroke-dasharray":
                              "62.83185307179586 62.83185307179586",
                            transform: "rotate(162.457 50 50)"
                          }
                        },
                        [
                          _c("animateTransform", {
                            attrs: {
                              attributeName: "transform",
                              type: "rotate",
                              calcMode: "linear",
                              values: "0 50 50;360 50 50",
                              keyTimes: "0;1",
                              dur: "1s",
                              begin: "0s",
                              repeatCount: "indefinite"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              : _vm.totalPages
              ? _c(
                  "div",
                  { staticClass: "c-movie" },
                  _vm._l(_vm.paginatedList, function(item) {
                    return _c("movie-item", {
                      key: item.id,
                      attrs: { item: item }
                    })
                  }),
                  1
                )
              : _vm.error
              ? _c("div", { staticClass: "error" }, [
                  _c("div", { staticClass: "c-message__info has-error" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "18",
                          viewBox: "0 0 18 18",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M9 0a9 9 0 109 9 9.026 9.026 0 00-9-9zm3.713 11.652l-1.061 1.06L9 10.06l-2.652 2.652-1.06-1.06L7.938 9 5.287 6.348l1.061-1.06L9 7.938l2.652-2.652 1.06 1.061L10.06 9l2.652 2.652z",
                            fill: "#DF2137"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("Error:")]),
                    _vm._v(" " + _vm._s(_vm.error) + "\n          ")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.totalPages > 1
              ? _c("v-pagination", {
                  attrs: {
                    "page-count": _vm.totalPages,
                    classes: _vm.bootstrapPaginationClasses
                  },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("footer")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }